const setHypothesis = (isTestGroup) => {
  const f = () => {
    if (!window.updateCart) {
      return;
    }
    clearInterval(t);
    window.updateCart({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          _ab_shipping: isTestGroup ? "1" : ""
        }
      })
    })
  }
  const t = setInterval(f, 100);
}
const resizeIconsWithText = () => {
  const f = () => {
    document.querySelectorAll('.icons-with-text gridy-slider').forEach(element => {
      clearInterval(t);
      console.log(".gridy-track", element.querySelectorAll(".gridy-track > div").length);
      if (element.querySelectorAll(".gridy-track > div").length > 3) {
        return;
      }
      element.dataset.iprDesktop = element.dataset.iprDesktop - 1;
      element.dataset.iprTablet = element.dataset.iprTablet - 1;
      if (Number(element.dataset.iprDesktop) < 3) {
        element.querySelector('.gridy-track').classList.remove('md-grid-cols-3');
        element.querySelector('.gridy-track').classList.add('md-grid-cols-2');
      }
    });
  }
  const t = setInterval(f, 100);
}

if (window.shoplift) {
  const hypothesisIds = [
    '019e4e75-c85f-7d3b-86cd-67245fccca8e',
    '019e4e88-5882-7852-8f84-4e7be06c733f',
    '019e4e8a-3fe6-76d9-b2d4-ebfb0627a3f7',
    '019e447b-9ff2-7adb-ad29-ef2232b830e5',
    '019e4e83-b0ac-7819-a32b-128653bdbbf8'
  ];
  Promise.all(hypothesisIds.map(id => window.shoplift.isHypothesisActive(id)))
  .then(results => {
    const isOneActive = results.some(result => result);
    if (isOneActive) {
      restyle();
      setHypothesis(true);
    } else {
      setHypothesis(false);
    }
  });
} else {
  setHypothesis(false);
}
const restyle = () => {
  const el = document.createElement('style');

  if (window.Shopify.shop === "daniel-wellington-eu.myshopify.com") {
    el.innerHTML = `
      .icons-with-text .gridy-track > div:nth-child(1) {
        display: none !important;
      }
      .icons-with-text gridy-slider {
        opacity: 0;
      }
      .section-in-view .icons-with-text gridy-slider.gridy-slider {
        transition: opacity 0.6s ease-in;
        opacity: 1;
      }
      .pdp-usp-container .pdp-usp:nth-child(1) {
        display: none !important;
      }
      .shipping-methods-section .shipping-methods__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
    `;
    resizeIconsWithText();
  } else if (window.Shopify.shop === "daniel-wellington-south-africa.myshopify.com") {
    el.innerHTML = `
      .icons-with-text .gridy-track > div:nth-child(1) {
        display: none !important;
      }
      .icons-with-text gridy-slider {
        opacity: 0;
      }
      .section-in-view .icons-with-text gridy-slider.gridy-slider {
        transition: opacity 0.6s ease-in;
        opacity: 1;
      }
      .shipping-methods-section .shipping-methods__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
      html[lang="en"] .product__tax {
        font-size: 0 !important;
      }
      html[lang="en"] .product__tax:after {
        content: "Tax included." !important;
        font-size: 8px !important;
      }
    `;
    resizeIconsWithText();
  } else if (window.Shopify.shop === "daniel-wellington-japan.myshopify.com") {
    el.innerHTML = `
      .shipping-methods-section .shipping-methods__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
    `;
  } else if (window.Shopify.shop === "daniel-wellington-australia.myshopify.com") {
    el.innerHTML = `
      .icons-with-text .gridy-track > div:nth-child(1) {
        display: none !important;
      }
      .icons-with-text gridy-slider {
        opacity: 0;
      }
      .section-in-view .icons-with-text gridy-slider.gridy-slider {
        transition: opacity 0.6s ease-in;
        opacity: 1;
      }
      .shipping-methods-section .shipping-methods__price {
        display: none !important;
      }
      #cart-shipping-notification {
        display: none !important;
      }
      html[lang="en"] .product__tax {
        font-size: 0 !important;
      }
      html[lang="en"] .product__tax:after {
        content: "Tax included." !important;
        font-size: 10px !important;
        margin-left: -4px;
      }
    `;
    resizeIconsWithText();
  }
  
  document.head.appendChild(el);
}
